import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import moment from 'moment';
import Select from 'react-select';
import {createArrayYears, dataYears, getQuarterDates} from '../../../helpers/common';
import {getPrintedForm, stateContractReset} from '../../../redux/actions/contractAction';
import {ActionButton} from '../../common';
import BackButton from '../../common/BackButton/BackButton';
import {Message} from '../../utilites';
import {
    timeOptionsGrossIncome,
    typeDataGrossIncome,
    typeGrossIncome,
    viewReports
} from '../../../helpers/data-constants';
import ReadExcel from './ReadExcel';
import '../reports.scss'
import './reportsGrossProceeds.scss'
import {value} from "lodash/seq";
import AppDatePicker from "../../utilites/DateRangePicker/AppDatePicker";
import RenderFacets from "../../utilites/RenderFacets/RenderFacets";

const ReportsGrossProceeds = () => {
    const {commonError, isLoading} = useSelector(({contract}) => contract);
    const dispatch = useDispatch();
    const [state, setState] = useState(null);
    const [fileName, setFileName] = useState('');
    const [selectValue, setSelectValue] = useState(null);
    const reportFormat = [{value: 'detail', label: 'Развернутый'}, {value: 'global', label: 'Итоговый'}];
    const availableYears = createArrayYears().map((i) => ({value: i, label: i}));
    const availableReportFormat = reportFormat.map((i) => i);
    const [dataTypePurity, setDataTypePurity] = useState({data: []});
    const {accessFeatures} = useSelector(({user}) => user);
    const [date, setDate] = useState({
        startDate: null,
        endDate: null
    });
    const [actualGrossIncomeState, setActualGrossIncomeState] = useState({
        dateFrom: null,
        dateTo: null,
        overpaymentType: [typeGrossIncome[0]],
        dealType: [{value: 'things', label: 'Вещи'}]
    })

    const actualGrossIncome = accessFeatures['report.gross_income.global']

    const [typeDataState, setTypeDataState] = useState(null)

    useEffect(() => {
        return () => {
            dispatch(stateContractReset());
        };
    }, [dispatch]);

    const chooseYears = (i) => {
        setState(dataYears(i, viewReports.GROSS_INCOME, viewReports.GROSS_INCOME));
    };

    const chooseReportFormat = (name) => {
        setSelectValue(name);
        if (name && Array.isArray(actualGrossIncomeState.type)) {
            if (!actualGrossIncomeState.type.find(({value}) => value === name.value)) {
                const newArrFullName = [...dataTypePurity.data]
                newArrFullName.push(name)

                setActualGrossIncomeState({
                    ...actualGrossIncomeState,
                    type: newArrFullName,
                });
            }
        }
    };

    useEffect(() => {
        if (typeDataState === null) {
            return
        }

        const {type, title, dateFrom, dateTo, viewReport, period} = typeDataState;

        let data = {
            dateFrom,
            dateTo,
            type: selectValue.value,
            period
        }

        if (accessFeatures['report.gross_income.extended']) {
            if (dataTypePurity.data.length) {
                data.dealType = dataTypePurity.data.map(el => el.value).join(',')
            } else {
                data.dealType = 'ALL'
            }
        } else {
            data.dealType = 'THINGS'
        }

        const filename = title + '_' + moment().format('DD.MM.YYYY') + '.xlsx';
        setFileName(filename)
        dispatch(getPrintedForm(data, filename, viewReport, type));
    }, [typeDataState, dataTypePurity, selectValue, state, date]);

    useEffect(() => {
        if (!actualGrossIncome && (actualGrossIncomeState.dateFrom || actualGrossIncomeState.dateTo)
            && actualGrossIncomeState.overpaymentType.length && actualGrossIncomeState.dealType.length) {
            let data = {
                dateFrom: actualGrossIncomeState.dateFrom ? moment(actualGrossIncomeState.dateFrom).format('YYYY-MM-DD') : null,
                dateTo: actualGrossIncomeState.dateTo ? moment(actualGrossIncomeState.dateTo).format('YYYY-MM-DD') : null,
                overpaymentType: actualGrossIncomeState.overpaymentType.map(el => el.value).join(','),
                type: 'detail',
                dealType: actualGrossIncomeState.dealType.map(el => el.value).join(',')
            };
            if (accessFeatures['report.gross_income.extended']) {
                if (dataTypePurity.data.length) {
                    data.dealType = dataTypePurity.data.map(el => el.value).join(',')
                } else {
                    data.dealType = 'ALL'
                }
            } else {
                data.dealType = 'THINGS'
            }

            const filename = `${actualGrossIncomeState.dateFrom}-${actualGrossIncomeState.dateTo}` + '_' + moment().format('DD.MM.YYYY') + '.xlsx';
            setFileName(filename)
            dispatch(getPrintedForm(data, filename, 'GROSS_INCOME', actualGrossIncomeState.type));
        }
    }, [actualGrossIncomeState, typeDataState, dataTypePurity, selectValue, state, date]);

    const chooseDataType = (name) => {
        if (name && Array.isArray(dataTypePurity.data)) {
            if (!dataTypePurity.data.find(({value}) => value === name.value)) {
                const newArrFullName = [...dataTypePurity.data]
                newArrFullName.push(name)

                setDataTypePurity({
                    ...state,
                    data: newArrFullName,
                });

                setActualGrossIncomeState({
                    ...actualGrossIncomeState,
                    dealType: newArrFullName,
                });
            }
        }
    }

    const chooseReportType = (name) => {
        if (name && Array.isArray(actualGrossIncomeState.overpaymentType)) {
            if (!actualGrossIncomeState.overpaymentType.find(({value}) => value === name.value)) {

                setActualGrossIncomeState({
                    ...actualGrossIncomeState,
                    overpaymentType: [name],
                });
            }
        }
    }

    const changeDataPicker = (values) => {
        setDate({...date, endDate: values.endDate, startDate: values.startDate});
        setActualGrossIncomeState({
            ...actualGrossIncomeState,
            dateFrom: values.startDate,
            dateTo: values.endDate
        })
    };

    const deleteChoise = (value) => {
        const filteredPurityType = dataTypePurity.data.filter(el => el.value !== value)

        setDataTypePurity((prev) => ({
            data: filteredPurityType,
        }));
    }

    const createButtons = (data) => {
        return Object.values(data).map((i) => (
            <ActionButton
                key={i.title}
                text={i.title}
                styleName="button-pillbox"
                func={() => setTypeDataState(i)}
                param={i}
            />
        ));
    };

    return (
        <main className="app-content">
            <div className="content-header reportsNBRB-content-header">
                <h1>Отчетность по выручке коммерческой микрофинансовой организации</h1>
                <div className="content-header-back reportsNBRB-content-header-back">
                    <BackButton/>
                </div>
            </div>
            <div className="content-inner">
                <div className="content-inner-data">
                    <div className="content-inner-data-columns">
                        <div className="content-inner-data-container widthContainer">
                            {commonError && <Message type="error" text={commonError}/>}
                            {isLoading && <Message type={"info"} text={`Отчет Валовый доход загружается, подождите!`}/>}
                            <fieldset>
                                <div className="m-b-0 reportGrossProceeds-search">
                                    <div className="reports-searchItems">
                                        <div className="reports-dataTypeItem">
                                            {
                                                !actualGrossIncome
                                                    ? <AppDatePicker
                                                        coverClass="form-element"
                                                        startDate={date.startDate}
                                                        endDate={date.endDate}
                                                        onChange={(v) => changeDataPicker(v)}
                                                        period={timeOptionsGrossIncome}
                                                    />
                                                    : <Select
                                                        classNamePrefix="select"
                                                        className="basic-multi-select select-width"
                                                        placeholder="Выберите год"
                                                        options={availableYears}
                                                        onChange={chooseYears}
                                                        noOptionsMessage={() => 'Нет результатов'}
                                                    />
                                            }
                                        </div>
                                        {
                                            actualGrossIncome &&
                                            <div className="reports-dataTypeItem">
                                                <Select
                                                    classNamePrefix="select"
                                                    className="basic-multi-select select-width"
                                                    placeholder="Формат отчета"
                                                    options={availableReportFormat}
                                                    onChange={chooseReportFormat}
                                                    noOptionsMessage={() => 'Нет результатов'}
                                                />
                                            </div>
                                        }

                                        {
                                            accessFeatures['report.gross_income.extended'] &&
                                            <div className="reports-dataTypeItem">
                                                <Select
                                                    classNamePrefix="select"
                                                    className="basic-multi-select select-width"
                                                    placeholder="Тип залога"
                                                    options={typeDataGrossIncome}
                                                    onChange={chooseDataType}
                                                    noOptionsMessage={() => 'Нет результатов'}
                                                />
                                            </div>
                                        }
                                        {
                                            !actualGrossIncome &&
                                            <Select
                                                classNamePrefix="select"
                                                className="basic-multi-select select-width"
                                                placeholder="Вид отчета"
                                                options={typeGrossIncome}
                                                defaultValue={typeGrossIncome[0]}
                                                onChange={chooseReportType}
                                                noOptionsMessage={() => 'Нет результатов'}
                                            />
                                        }
                                    </div>
                                </div>
                                <div>
                                    <span className='reports'>Тип залога:</span>
                                    <RenderFacets
                                        facets={dataTypePurity.data}
                                        onClickFacet={(value) => deleteChoise(value)}
                                    />
                                </div>
                            </fieldset>
                            {
                                actualGrossIncome &&
                                <fieldset>
                                    <div className="reports-cardscontainer">
                                        <div className="reports-cardcolumn w-25">
                                            <div className="reports-card">
                                                <div className="reports-card-header">
                                                    <h4>Месячный</h4>
                                                </div>
                                                <div className="reports-card-content">
                                                    {state && selectValue && createButtons(state.months)}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="reports-cardcolumn w-25">
                                            <div className="reports-card">
                                                <div className="reports-card-header">
                                                    <h4>Квартальный</h4>
                                                </div>
                                                <div className="reports-card-content">
                                                    {state && selectValue && createButtons(state.quarter)}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="reports-cardcolumn w-25">
                                            <div className="reports-card">
                                                <div className="reports-card-header">
                                                    <h4>Годовой</h4>
                                                </div>
                                                <div className="reports-card-content">
                                                    {state && selectValue && createButtons(state.year)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            }
                            <ReadExcel
                                fileName={fileName}
                                setTypeDataState={setTypeDataState}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ReportsGrossProceeds;